export const hasBlockingRepairOrders = (orders = []) => orders.some((order) =>
    !order.isArchived && !(order.status === 'completed' && order.returnedToSupportAt)
);
